import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

import { AnalyticsService, ApplicationInsightsService } from '@crosscutting/public_api';
import { VMDataService } from './vmdata.service';

@Injectable()
export class VMComponentsErrorHandler implements ErrorHandler {
  constructor(private _injector: Injector) { }

  handleError(error: Error | HttpErrorResponse) {
    const analyticsService = this._injector.get(AnalyticsService);
    const router = this._injector.get(Router);
    const vmDataService = this._injector.get(VMDataService);
    const applicationInsightsService = this._injector.get(ApplicationInsightsService);
    
    if (environment.production) {
      try {
        if (error instanceof HttpErrorResponse) {
          // Server error has occured, like webapi call

          if (!navigator.onLine) {
            // Handle offline error
          } else {
            // Handle Http Error (error.status === 403, 404...)
            analyticsService.googleEmitEvent('error', 'server', this.constructLabelWebApiError(error));
          }
        } else {
          // Client side error has occured
          const code = `vm-unknown-${this.filterCharacters(router.url)}`;
          analyticsService.googleEmitEvent('error', 'client', code);
        }

        // log to application insights
        applicationInsightsService.logError(error);
      } catch {
        // Do nothing --> Logging error can not result in new exception
      }

      vmDataService.forceNavigation = true;
      router.navigate(['/error']);
    }

    // log it to the console
    console.log(error);
  }

  private constructLabelWebApiError(error: HttpErrorResponse): string {
    if (!error) {
      return null;
    }

    const url = this.filterCharacters(error.url);
    return `vm-${error.status}-${url}`;
  }

  private filterCharacters(value: string) {
    let returnValue = value;
    if (returnValue) {
      returnValue = returnValue.replace(/http(s)?:\/\/(www)?/g, '');
      returnValue = returnValue.replace(/\//g, '_');
      returnValue = returnValue.replace(/[^\d\w]/g, '');
    }

    return returnValue;
  }
}
